import { render, staticRenderFns } from "./huapengfa.vue?vue&type=template&id=2c090b8e&scoped=true"
import script from "./huapengfa.vue?vue&type=script&lang=js"
export * from "./huapengfa.vue?vue&type=script&lang=js"
import style0 from "./huapengfa.vue?vue&type=style&index=0&id=2c090b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c090b8e",
  null
  
)

export default component.exports